import { render } from "./LineChartG.vue?vue&type=template&id=1152d5a1&scoped=true"
import script from "./LineChartG.vue?vue&type=script&lang=ts"
export * from "./LineChartG.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1152d5a1"

export default script